//@flow

import type {LogoPaymentMethodCategory} from './paymentData';

export type PaymentMethodField = {
  label: string,
  value: string,
  type: 'text' | 'number' | 'currency' | 'document_type',
  required: boolean,
};

const instructionsField: PaymentMethodField = {
  label: 'Instrucciones',
  value: 'instructions',
  required: false,
  type: 'text',
};

const accountHolderField: PaymentMethodField = {
  label: 'Titular de la cuenta',
  value: 'accountHolder',
  required: true,
  type: 'text',
};

const accountNumberField: PaymentMethodField = {
  label: 'Número de cuenta',
  value: 'accountNumber',
  required: true,
  type: 'number',
};

const interbankNumberField: PaymentMethodField = {
  label: 'Número de interbancario',
  value: 'interbankNumber',
  required: true,
  type: 'number',
};

const documentNumberField = (required = false): PaymentMethodField => ({
  label: 'Número de documento',
  value: 'documentNumber',
  required,
  type: 'text',
});

const numberMethodField: PaymentMethodField = {
  label: 'Número',
  value: 'numberMethod',
  required: true,
  type: 'text',
};

const moneyField: PaymentMethodField = {
  label: 'Moneda',
  value: 'currency',
  required: true,
  type: 'currency',
};

const documentTypeField = (required = false): PaymentMethodField => ({
  label: 'Tipo de documento',
  value: 'documentType',
  type: 'document_type',
  required,
});

export const INPUT_FIELDS_BY_PAYMENT_METHOD: {
  [key: LogoPaymentMethodCategory]: PaymentMethodField[],
} = {
  bank: [
    accountHolderField,
    accountNumberField,
    interbankNumberField,
    moneyField,
    documentTypeField(true),
    documentNumberField(true),
    instructionsField,
  ],
  digital_wallet: [
    accountHolderField,
    numberMethodField,
    moneyField,
    documentTypeField(),
    documentNumberField(),
    instructionsField,
  ],
  cash_on_delivery: [instructionsField],
  others: [
    accountHolderField,
    accountNumberField,
    interbankNumberField,
    moneyField,
    documentTypeField(),
    documentNumberField(),
    instructionsField,
  ],
};
